<!-- From / To dropdown over the field: the results-page search's airport picker, same values, in Tailwind -->
<div
  class="absolute -top-3.5 -left-3.5 rtl:left-auto rtl:-right-3.5 z-50 flex flex-col gap-3 w-[620px] max-w-[calc(100vw-32px)] max-h-[70vh] p-4 rounded-[14px] font-nunito text-[#161a25] bg-white dark:bg-[#1e1e48] dark:text-[#f1f1f1] shadow-[0_12px_32px_rgba(22,26,37,.12),0_0_0_1px_#eaeaea] cursor-auto text-left rtl:text-right motion-safe:transition-[opacity,translate] motion-safe:duration-[160ms] motion-safe:ease-out starting:opacity-0 starting:-translate-y-1"
  role="dialog"
  [attr.aria-label]="labelKey | translate"
>
  <!-- the field, on top -->
  <div
    class="flex flex-col justify-center gap-1 min-h-14 py-1.5 px-4 rounded-[10px] bg-[#f1f9ff] dark:bg-[#22225e] shadow-[inset_0_0_0_1px_#eaeaea] dark:shadow-[inset_0_0_0_1px_#2c2c6a]"
  >
    <span class="text-sm leading-5 font-semibold text-[#6b7280] dark:text-[#b4b7c9]">{{ labelKey | translate }}</span>
    <span class="flex items-center gap-2">
      <ng-container [ngTemplateOutlet]="planeTpl" />
      <input
        #field
        class="flex-1 min-w-0 p-0 border-0 bg-transparent shadow-none outline-none focus:outline-none focus:ring-0 focus:border-0 text-base leading-[22px] font-bold text-[#242456] dark:text-[#f1f1f1] placeholder:text-[#6b7280] placeholder:font-normal dark:placeholder:text-[#b4b7c9]"
        type="text"
        role="combobox"
        autocomplete="off"
        spellcheck="false"
        aria-autocomplete="list"
        [attr.aria-label]="'Search.Type_City' | translate"
        [attr.aria-expanded]="view() !== 'home'"
        [attr.aria-controls]="'ap-list-' + cityType() + index()"
        [attr.aria-activedescendant]="active() >= 0 ? 'ap-opt-' + cityType() + index() + '-' + active() : null"
        [placeholder]="current() ? current()!.city + ', ' + current()!.country : ('Search.Where_To_Go' | translate)"
        [value]="term()"
        (input)="onType($any($event.target).value)"
        (keydown)="onKey($event)"
      />
      @if (term()) {
      <button
        type="button"
        class="flex-none grid place-items-center w-7 h-7 rounded-full text-[#369be7]"
        [attr.aria-label]="'Search.Clear_Field' | translate"
        (click)="$event.preventDefault(); clearTerm()"
      >
        <svg class="w-7 h-7" viewBox="0 0 32 32" fill="none" aria-hidden="true">
          <path
            d="M16 2.667C8.653 2.667 2.667 8.653 2.667 16C2.667 23.347 8.653 29.333 16 29.333C23.347 29.333 29.333 23.347 29.333 16C29.333 8.653 23.347 2.667 16 2.667ZM20.48 19.067C20.867 19.453 20.867 20.093 20.48 20.48C20.28 20.68 20.027 20.773 19.773 20.773C19.52 20.773 19.267 20.68 19.067 20.48L16 17.413L12.933 20.48C12.733 20.68 12.48 20.773 12.227 20.773C11.973 20.773 11.72 20.68 11.52 20.48C11.133 20.093 11.133 19.453 11.52 19.067L14.587 16L11.52 12.933C11.133 12.547 11.133 11.907 11.52 11.52C11.907 11.133 12.547 11.133 12.933 11.52L16 14.587L19.067 11.52C19.453 11.133 20.093 11.133 20.48 11.52C20.867 11.907 20.867 12.547 20.48 12.933L17.413 16L20.48 19.067Z"
            fill="currentColor"
          />
        </svg>
      </button>
      }
    </span>
  </div>

  <div
    class="flex flex-col gap-1.5 flex-auto min-h-0 overflow-y-auto overscroll-contain py-2.5 pe-1.5 -me-1.5 [mask-image:linear-gradient(transparent_0,#000_8px,#000_calc(100%-8px),transparent_100%)]"
  >
    @switch (view()) {
    <!-- a popular city: its airports -->
    @case ("city") {
    <div class="flex items-center justify-start gap-2.5 min-h-9">
      <button
        type="button"
        class="text-sm leading-5 font-semibold text-[#369be7] hover:underline"
        [attr.aria-label]="'Search.Back_To_Cities' | translate"
        (click)="backToCities()"
      >
        ‹ {{ "Search.All_Cities" | translate }}
      </button>
      <span class="text-sm leading-5 font-semibold text-[#6b7280] dark:text-[#b4b7c9]">
        {{ "Search.Airports_In" | translate : { city: city() } }}@if (!loading()) { · {{ cityAirports().length }} }
      </span>
    </div>
    <div class="flex flex-col gap-1.5 py-px" role="listbox" [id]="'ap-list-' + cityType() + index()">
      @if (loading()) {
      <p class="m-1.5 text-sm text-[#6b7280] dark:text-[#b4b7c9]" role="status">{{ "Search.Searching" | translate }}</p>
      } @else { @for (a of cityAirports(); track a.iata) {
      <ng-container [ngTemplateOutlet]="optTpl" [ngTemplateOutletContext]="{ a }" />
      } @empty {
      <p class="m-1.5 text-sm text-[#6b7280] dark:text-[#b4b7c9]">{{ "Search.No_Airports_Match" | translate : { term: city() } }}</p>
      } }
    </div>
    }

    <!-- typed: grouped by city -->
    @case ("typed") {
    <div class="flex flex-col gap-1.5 py-px" role="listbox" [id]="'ap-list-' + cityType() + index()">
      @if (loading() && !groups().length) {
      <p class="m-1.5 text-sm text-[#6b7280] dark:text-[#b4b7c9]" role="status">{{ "Search.Searching" | translate }}</p>
      } @else { @for (g of groups(); track g.city + g.country) {
      <div
        class="flex flex-col gap-1.5 [&+&]:mt-1.5"
        role="group"
        [attr.aria-label]="'Search.Airports_In' | translate : { city: g.city + ', ' + g.country }"
      >
        <span class="flex items-center gap-1.5 pt-0.5 px-0.5 text-sm leading-5 font-semibold text-[#6b7280] dark:text-[#b4b7c9]">
          <ng-container [ngTemplateOutlet]="pinTpl" [ngTemplateOutletContext]="{ size: 'w-4 h-4' }" />{{ g.city }}, {{ g.country }} ·
          {{
            g.airports.length === 1
              ? ("Search.Airport_Count_One" | translate)
              : ("Search.Airports_Count" | translate : { count: g.airports.length })
          }}
        </span>
        @for (a of g.airports; track a.iata) {
        <ng-container [ngTemplateOutlet]="optTpl" [ngTemplateOutletContext]="{ a }" />
        }
      </div>
      } @empty {
      <p class="m-1.5 text-sm text-[#6b7280] dark:text-[#b4b7c9]">{{ "Search.No_Airports_Match" | translate : { term: term() } }}</p>
      } }
    </div>
    }

    <!-- nothing typed: recent searches and popular cities -->
    @default {
    <div class="flex items-center justify-between min-h-9">
      <span class="text-sm leading-5 font-semibold text-[#6b7280] dark:text-[#b4b7c9]">{{ "Search.Recent_Searches" | translate }}</span>
      @if (recent().length) {
      <button type="button" class="py-1.5 text-sm leading-5 font-semibold text-[#369be7] hover:underline" (click)="clearRecent()">
        {{ "Search.Clear_All" | translate }}
      </button>
      }
    </div>
    @if (recent().length) {
    <div class="grid grid-cols-1 sm:grid-cols-2 gap-x-2.5 gap-y-1.5">
      @for (r of recent(); track r.iata) {
      <button
        type="button"
        class="flex items-center justify-between gap-2 min-w-0 min-h-10 py-2 px-3 rounded-lg text-start text-sm leading-5 font-semibold text-[#242456] dark:text-[#f1f1f1] hover:bg-[#e6f0fb] hover:shadow-[inset_0_0_0_1px_#369be7] dark:hover:bg-[#2c2c6a] focus-visible:outline-none focus-visible:bg-[#e9f2fc] dark:focus-visible:bg-[#2c2c6a]"
        (click)="pick(r)"
      >
        <span class="truncate min-w-0">{{ r.name }}, {{ r.country }} ({{ r.iata }})</span>
        <svg class="flex-none w-[18px] h-[18px] text-[#6b7280] dark:text-[#b4b7c9]" viewBox="0 0 20 20" fill="none" aria-hidden="true">
          <path d="M17.08 17.7H2.91C2.57 17.7 2.29 17.99 2.29 18.33C2.29 18.67 2.57 18.95 2.91 18.95H17.08C17.42 18.95 17.7 18.67 17.7 18.33C17.7 17.99 17.42 17.7 17.08 17.7Z" fill="currentColor" />
          <path d="M4.16 12.1C4.5 12.1 4.79 11.81 4.79 11.47V4.42L15.39 15.02C15.51 15.15 15.67 15.2 15.83 15.2C15.99 15.2 16.14 15.15 16.27 15.02C16.51 14.78 16.51 14.38 16.27 14.14L5.67 3.54H12.72C13.06 3.54 13.34 3.25 13.34 2.91C13.34 2.57 13.06 2.29 12.72 2.29H4.16C4.08 2.29 4 2.3 3.92 2.34C3.77 2.4 3.64 2.52 3.59 2.67C3.55 2.75 3.54 2.83 3.54 2.91V11.47C3.54 11.81 3.82 12.1 4.16 12.1Z" fill="currentColor" />
        </svg>
      </button>
      }
    </div>
    } @else {
    <p class="m-1.5 text-sm text-[#6b7280] dark:text-[#b4b7c9]">{{ "Search.No_Recent_Searches" | translate }}</p>
    }
    <div class="flex items-center justify-between min-h-7 mt-2">
      <span class="text-sm leading-5 font-semibold text-[#6b7280] dark:text-[#b4b7c9]">{{ "Search.Popular_Cities" | translate }}</span>
    </div>
    <div class="grid grid-cols-3 sm:grid-cols-5 gap-x-2.5 gap-y-1.5">
      @for (c of popularCities; track c) {
      <button
        type="button"
        class="flex items-center gap-1.5 min-w-0 min-h-10 py-2 px-3 rounded-lg text-start text-sm leading-5 font-semibold text-[#242456] dark:text-[#f1f1f1] hover:bg-[#e6f0fb] hover:shadow-[inset_0_0_0_1px_#369be7] dark:hover:bg-[#2c2c6a] focus-visible:outline-none focus-visible:bg-[#e9f2fc] dark:focus-visible:bg-[#2c2c6a]"
        [ngClass]="{ 'bg-[#eef5fd] dark:bg-[#22225e]': isChosenCity(c) }"
        [attr.title]="'Search.Airports_In' | translate : { city: c }"
        (click)="openCity(c)"
      >
        <ng-container [ngTemplateOutlet]="pinTpl" [ngTemplateOutletContext]="{ size: 'w-[18px] h-[18px]' }" /><span class="truncate">{{ c }}</span>
      </button>
      }
    </div>
    } }
  </div>
</div>

<!-- an airport: "Egypt, Cairo, SPX, Sphinx International Airport" -->
<ng-template #optTpl let-a="a">
  <button
    type="button"
    role="option"
    class="group flex items-center gap-1.5 min-h-12 ps-2 pe-4 rounded-[10px] text-start bg-[#f6f9fd] dark:bg-[#22225e] hover:bg-[#e9f2fc] dark:hover:bg-[#2c2c6a] focus-visible:outline-none focus-visible:bg-[#e9f2fc] dark:focus-visible:bg-[#2c2c6a] aria-selected:bg-[#e9f2fc] dark:aria-selected:bg-[#2c2c6a]"
    [id]="'ap-opt-' + cityType() + index() + '-' + indexOf(a)"
    [attr.aria-selected]="indexOf(a) === active()"
    (click)="pick(a)"
  >
    <i class="flex-none grid place-items-center w-8 h-8 text-[#6b7280] dark:text-[#b4b7c9] group-hover:text-[#369be7] group-aria-selected:text-[#369be7]">
      <ng-container [ngTemplateOutlet]="pinTpl" [ngTemplateOutletContext]="{ size: 'w-5 h-5' }" />
    </i>
    <span
      class="text-sm leading-5 font-medium text-[#242456] dark:text-[#f1f1f1] group-hover:text-[#1f78c1] group-aria-selected:text-[#1f78c1] dark:group-hover:text-[#7cc0f2] dark:group-aria-selected:text-[#7cc0f2]"
      >{{ a.country }}, {{ a.city }}, {{ a.iata }}, {{ a.name }}</span
    >
  </button>
</ng-template>

<ng-template #pinTpl let-size="size">
  <svg class="flex-none" [ngClass]="size" viewBox="0 0 20 20" fill="none" aria-hidden="true">
    <path d="M10 11.808C8.225 11.808 6.775 10.367 6.775 8.583C6.775 6.8 8.225 5.367 10 5.367C11.775 5.367 13.225 6.808 13.225 8.592C13.225 10.375 11.775 11.808 10 11.808ZM10 6.617C8.917 6.617 8.025 7.5 8.025 8.592C8.025 9.683 8.908 10.567 10 10.567C11.092 10.567 11.975 9.683 11.975 8.592C11.975 7.5 11.083 6.617 10 6.617Z" fill="currentColor" />
    <path d="M10 18.967C8.766 18.967 7.524 18.5 6.558 17.575C4.1 15.208 1.383 11.433 2.408 6.942C3.333 2.867 6.891 1.042 10 1.042H10.008C13.116 1.042 16.674 2.867 17.6 6.95C18.616 11.442 15.9 15.208 13.441 17.575C12.474 18.5 11.233 18.967 10 18.967ZM10 2.292C7.574 2.292 4.458 3.583 3.633 7.217C2.733 11.142 5.2 14.525 7.433 16.667C8.874 18.058 11.133 18.058 12.574 16.667C14.8 14.525 17.266 11.142 16.383 7.217C15.549 3.583 12.424 2.292 10 2.292Z" fill="currentColor" />
  </svg>
</ng-template>

<!-- take-off (From) / landing (To) -->
<ng-template #planeTpl>
  <svg class="flex-none w-5 h-5 text-[#86c3f1]" viewBox="0 0 24 24" fill="none" aria-hidden="true">
    @if (cityType() === "from") {
    <path d="M20.936 8.72L20.706 8.16C20.411 7.51 19.934 6.96 19.332 6.576C18.73 6.193 18.03 5.992 17.316 6C16.538 5.999 15.777 6.225 15.126 6.65L7.306 11.54L6.006 10.64C5.83 10.522 5.623 10.459 5.411 10.459C5.199 10.459 4.992 10.522 4.816 10.64L3.006 11.74L6.576 15.67C6.735 15.833 6.941 15.943 7.164 15.984C7.388 16.025 7.619 15.996 7.826 15.9L11.456 14.17L11.006 18L13.746 16.18C13.914 16.065 14.044 15.901 14.116 15.71L15.316 12.63C15.41 12.391 15.593 12.198 15.826 12.09L20.456 9.88C20.671 9.787 20.842 9.614 20.932 9.397C21.021 9.181 21.023 8.938 20.936 8.72Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    } @else {
    <path d="M20.418 16.444L20.68 15.898C20.966 15.244 21.056 14.521 20.938 13.817C20.82 13.113 20.5 12.459 20.017 11.934C19.497 11.355 18.82 10.941 18.069 10.741L9.202 8.202L9.001 6.633C8.971 6.424 8.879 6.228 8.737 6.07C8.596 5.913 8.41 5.801 8.205 5.749L6.176 5.14L5.645 10.423C5.63 10.65 5.686 10.876 5.805 11.07C5.924 11.264 6.101 11.416 6.31 11.506L10.025 13.046L6.877 15.274L10.063 16.092C10.262 16.14 10.47 16.127 10.66 16.053L13.752 14.884C13.993 14.794 14.258 14.8 14.494 14.901L19.235 16.863C19.448 16.961 19.691 16.972 19.912 16.894C20.133 16.816 20.314 16.654 20.418 16.444Z" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round" />
    }
  </svg>
</ng-template>
